import React from "react";
import { condicionVenta, medioPago } from "../../catalogos";
import { currencyFormat, dateFormatNow, getServiciosProfecionales } from "../../util";

export class ImprimirTiquete extends React.PureComponent {

    constructor(props) {
        super(props);
        const { data, direccionEmisorState, direccionReceptorState } = props;
        this.state = {
            data: data,
            detalle: data.DetalleServicio.LineaDetalle,
            direccionEmisor: direccionEmisorState,
            direccionReceptor: direccionReceptorState,
            ResumenFactura: data.ResumenFactura
        };
    }

    getImpuesto = (impuestos = []) => {
        let monto = 0;
        impuestos.forEach((i) => {
            monto += i.Monto;
        });
        return (<span>{currencyFormat(monto)}</span>);
    }

    getMedioPago = (value) => {

        if (value !== null) {
            return medioPago.filter((item) => item.value === value)[0].display;
        }
        return 'Verificar';
    };

    getCondicionVenta = (value) => {

        if (value !== null) {
            return condicionVenta.filter((item) => item.value === value)[0].display;
        }
        return 'Verificar';
    };

    componentDidUpdate() {
        const { direccionReceptorState } = this.props;
        if (this.state.data.Receptor?.Ubicacion) {
            this.setState(
                this.state.direccionReceptor = direccionReceptorState
            );
        }
    }

    render() {
        return (
            <div style={{maxWidth: "75mm", margin: "10px 5px 10px 5px", fontWeight:"bold"}} className="ui grid">

                <div className="sixteen wide column">
                    {dateFormatNow(Date.now())}
                </div>

                <div className="sixteen wide column">
                    <h4>Factura # {this.state.data.NumeroConsecutivo}  </h4>
                </div>

                <div className="sixteen wide column" style={{ marginTop: "-15px" }}>
                    <div style={{ marginBottom: "1px" }}>
                        <h4>{this.state.data.Emisor.NombreComercial}</h4>
                    </div>
                    <div>
                        <strong>{this.state.data.Emisor.Nombre}</strong> <strong>(Nombre)</strong>
                    </div>
                    <div>
                        <strong>Cédula Jurídica:</strong> {this.state.data.Emisor.Identificacion.Numero}
                    </div>
                    <div>
                        {
                            this.state.data.Emisor.Telefono && <div>
                                <strong>Teléfono:</strong>
                                (+{this.state.data.Emisor.Telefono.CodigoPais}) {this.state.data.Emisor.Telefono.NumTelefono}
                            </div>
                        }
                    </div>
                </div>

                <div className="sixteen wide column" style={{ marginTop: "-15px" }}>
                    <div>
                        <strong>Correo: </strong> {this.state.data.Emisor.CorreoElectronico}
                    </div>
                    <div>
                        {
                            this.state.data.Emisor.Ubicacion && <div>
                                <strong>Dirección:</strong>&nbsp;
                                {this.state.direccionEmisor.NombreProvincia},&nbsp;
                                {this.state.direccionEmisor.NombreCanto}, &nbsp;
                                {this.state.direccionEmisor.NombreDistrito}, &nbsp;
                                {this.state.direccionEmisor.NombreBarrio}
                            </div>
                        }
                    </div>
                </div>

                <div className="sixteen wide column" style={{ marginTop: "-15px" }}>
                    <div style={{ marginBottom: "1px" }}>
                        <h4>Información del Cliente</h4>
                    </div>
                    <div>
                        <strong>Cliente: </strong> {this.state.data.Receptor?.Nombre ? this.state.data.Receptor?.Nombre: ""}
                    </div>
                    <div>
                        <strong>Cédula: </strong> {this.state.data.Receptor?.Identificacion.Numero? this.state.data.Receptor?.Identificacion.Numero: ""}
                    </div>
                    <div>
                        <strong>Correo: </strong> {this.state.data.Receptor?.CorreoElectronico? this.state.data.Receptor?.CorreoElectronico: ""}
                    </div>
                    <div>
                        {
                            this.state.data.Receptor?.Telefono && <div>
                                <strong>Teléfono:</strong> (+{this.state.data.Receptor.Telefono.CodigoPais}) {this.state.data.Receptor.Telefono.NumTelefono}
                            </div>
                        }
                    </div>
                    <div>
                        {
                             this.state.direccionReceptor && <div>
                                <strong>Dirección:</strong>&nbsp;
                                {this.state.direccionReceptor.NombreProvincia},&nbsp;
                                {this.state.direccionReceptor.NombreCanto}, &nbsp;
                                {this.state.direccionReceptor.NombreDistrito}, &nbsp;
                                {this.state.direccionReceptor.NombreBarrio}
                            </div>
                        }
                    </div>
                </div>

                <div className="sixteen wide column" style={{ marginTop: "-15px" }}>
                    <div>
                        <strong>Clave Hacienda: </strong> <small style={{ fontSize: "61%" }}>{this.state.data.Clave}</small>
                    </div>
                    <div>
                        <strong>Fecha de Emision: </strong> {dateFormatNow(this.state.data.FechaEmision)}
                    </div>
                    <div>
                        <strong>Condicion de Venta:</strong> {this.getCondicionVenta(this.state.data.CondicionVenta)}
                    </div>
                    <div>
                        <strong>Medio de Pago:</strong> {this.getMedioPago(this.state.data.MedioPago)}
                    </div>
                </div>

                <div className="sixteen wide column" style={{ marginTop: "-15px" }}>
                    <div style={{ marginBottom: "1px" }}>
                        <h4>Detalle de la Factura</h4>
                    </div>
                    <table className="ui very basic table">
                        <thead>
                            <tr>
                                <th style={{ padding: "1px" }}>Descripción</th>
                                <th style={{ padding: "1px" }}>Cant</th>
                                <th style={{ alignItems: "right", padding: "1px" }} >Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.detalle.map((item) => (
                                <tr style={{ fontSize: "15px", fontWeight: "bolder" }} key={item.Detalle}>
                                    <td style={{ padding: "1px" }}>
                                        {
                                            getServiciosProfecionales(item.UnidadMedida) ? <div>S - {item.Detalle}</div> : <div>P - {item.Detalle}</div>
                                        }
                                    </td>
                                    <td style={{ padding: "1px" }}><span>{item.Cantidad}</span></td>
                                    <td style={{ padding: "1px" }}><span style={{ "white-space": "nowrap" }}>{currencyFormat(item.MontoTotalLinea)}</span></td>
                                    <td style={{ padding: "1px", display: "none" }}><span style={{ "white-space": "nowrap" }}>{this.getImpuesto(item.Impuestos?.Impuesto)}</span></td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>

                <div className="right floated sixteen wide column" style={{ textAlign: "right", marginTop: "-15px" }} >

                    <div className="ui right aligned grid">
                        <div className="center aligned two column row">
                            <div className="ten wide column">
                                <div className="ui">
                                    <div>
                                        <strong>Código Moneda:</strong>
                                    </div>

                                    {
                                        (this.state.ResumenFactura.CodigoTipoMoneda.TipoCambio === 'CRC') && (
                                            <div>
                                                <strong>Tipo de Cambio:</strong>
                                            </div>
                                        )}

                                    <div>
                                        <strong>Sub Total:</strong>
                                    </div>
                                    <div>
                                        <strong>Gravado Total:</strong>
                                    </div>
                                    <div>
                                        <strong>Excento Total:</strong>
                                    </div>
                                    <div>
                                        <strong>Impuesto Total:</strong>
                                    </div>
                                    <div>
                                        <strong>Descuento Total:</strong>
                                    </div>
                                    <div>
                                        <strong>Total:</strong>
                                    </div>
                                </div>
                            </div>
                            <div className="six wide column">
                                <div className="ui" style={{ display: "inline-block", "text-align": "right" }}>

                                    <div>
                                        {this.state.ResumenFactura.CodigoTipoMoneda.CodigoMoneda}
                                    </div>
                                    {
                                        (this.state.ResumenFactura.CodigoTipoMoneda.TipoCambio === 'CRC') && (
                                            <div>
                                                {currencyFormat(this.state.ResumenFactura.CodigoTipoMoneda.TipoCambio, 2, "$")}
                                            </div>
                                        )
                                    }
                                    <div style={{ "justify-content": "flex-end" }}>
                                        <span style={{ "white-space": "nowrap" }}>{currencyFormat(this.state.ResumenFactura.TotalVenta)}</span>
                                    </div>
                                    <div style={{ "justify-content": "flex-end" }}>
                                        <span style={{ "white-space": "nowrap" }}>{currencyFormat(this.state.ResumenFactura.TotalGravado)}</span>
                                    </div>
                                    <div style={{ "justify-content": "flex-end" }}>
                                        <span style={{ "white-space": "nowrap" }}>{currencyFormat(this.state.ResumenFactura.TotalExonerado)}</span>
                                    </div>
                                    <div style={{ "text-align": "right" }}>
                                        <span style={{ "white-space": "nowrap" }}>{currencyFormat(this.state.ResumenFactura.TotalImpuesto)}</span>
                                    </div>
                                    <div style={{ "justify-content": "flex-end" }}>
                                        <span style={{ "white-space": "nowrap" }}>{currencyFormat(this.state.ResumenFactura.TotalDescuentos)}</span>
                                    </div>
                                    <div style={{ "justify-content": "flex-end" }}>
                                        <span style={{ "white-space": "nowrap" }}>{currencyFormat(this.state.ResumenFactura.TotalComprobante)}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="sixteen wide column" style={{ marginTop: "-15px" }}>
                    <div>
                        <strong>Notas Adicionales</strong>
                    </div>
                    <div>
                        <p>La S. representa servicio, P. representa Producto</p>
                        <p>{this.state?.data?.Otros?.OtroTexto}</p>
                    </div>
                </div>
 
                <div className="sixteen wide column"  style={{ marginTop: "-15px" }}>
                    <div>
                        <strong>Autorizado mediante resolución MH-DGT-RES-0027-2024 Compatible con la versión 4.4</strong>
                    </div>
                    <div  style={{ marginTop: "-8px" }}>
                        Facturación en línea: https://www.facturacion-enlinea.com
                    </div>
                </div>


            </div>
        );
    }
}

